import { Link } from 'react-router-dom';
import logo1 from "../../assets/img/logo-3.png";
import logo2 from "../../assets/img/logo-2.png";
import subscribeBg from "../../assets/img/page/subscribe.jpg";
import Social from '../../data/social';

const FooterFour = () => {
    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className="footer__four">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="footer__four-area text-center d-flex flex-column align-items-center gap-4">
                            <div className="footer__four-widget">
                                <Link className="logo text-center" to="/" onClick={handleClick}>
                                    <img className='dark-n' src={logo1} alt="image" />
                                    <img className='light-n' src={logo2} alt="image" />
                                </Link>
                            </div>
                            
                            <div className="footer__four-menu d-flex justify-content-center align-items-center flex-wrap gap-3">
                                <Link to="/" onClick={handleClick}><span className='footer__four-menu-item'>Anasayfa</span></Link>
                                <Link to="/hakkimizda" onClick={handleClick}><span className='footer__four-menu-item'>Hakkımızda</span></Link>
                                <Link to="/projeler" onClick={handleClick}><span className='footer__four-menu-item'>Projeler</span></Link>
                                <Link to="/iletisim" onClick={handleClick}><span className='footer__four-menu-item'>İletişim</span></Link>
                            </div>

                            <div className="copyright__area-social text-center">
                                <Social />							
                            </div>
                            
                            <div className="copyright__area-content">
                                <p>© 2026, Ayyıldız İnşaat. Tüm hakları saklıdır.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FooterFour;